export const ASSETS = {
  emblem: 'https://customer-assets-v7afamib.emergentagent.net/job_a61ae34e-5f0e-4e4a-8f1e-b5cf1d7c5a34/artifacts/2454cf822bd2ca11_GSLAB_Logo_Emblem_Only.png',
  icon: 'https://customer-assets-v7afamib.emergentagent.net/job_a61ae34e-5f0e-4e4a-8f1e-b5cf1d7c5a34/artifacts/953ade450ac724b1_GSLAB_Logo_Icon_512x512.png',
  fullLogo: 'https://customer-assets-v7afamib.emergentagent.net/job_a61ae34e-5f0e-4e4a-8f1e-b5cf1d7c5a34/artifacts/733d9aa2adab2a31_GSLAB_Logo_Full_HighRes.jpg',
  banner: 'https://customer-assets-v7afamib.emergentagent.net/job_a61ae34e-5f0e-4e4a-8f1e-b5cf1d7c5a34/artifacts/474637e8449216a7_GSLAB_Social_Banner_1200x630.png',
  workstation: 'https://images.unsplash.com/photo-1510519138101-570d1dca3d66?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGVuZ2luZWVyJTIwZGFyayUyMHdvcmtzdGF0aW9ufGVufDB8fHx8MTc4OTIzOTY2MHww&ixlib=rb-4.1.0&q=85',
  cloud: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxjbG91ZCUyMHNlcnZlciUyMGluZnJhc3RydWN0dXJlJTIwYXJjaGl0ZWN0dXJlJTIwZ2xvd3xlbnwwfHx8fDE3OTM4MTQ4OTd8MA&ixlib=rb-4.1.0&q=85',
};

export const WINBACK_PACKAGES = {
  engine_launch_winback: { name: 'Sales Engine — Launch', price: 2545, original: 2995, unit: 'one-time' },
  engine_scale_winback: { name: 'Sales Engine — Scale', price: 4245, original: 4995, unit: 'one-time' },
  care_essentials_winback: { name: 'Care Plan — Essentials', price: 84, original: 99, unit: '/month' },
  care_growth_winback: { name: 'Care Plan — Growth', price: 211, original: 249, unit: '/month' },
};

export const GOOGLE_REVIEW_URL = '';

export const CONTACT = {
  email: 'jhk505@gatech.edu',
  phone: '706-304-1620',
  portfolio: 'https://gabekimportfolio.pages.dev/',
  domain: 'gslab.engineer',
};

export const PACKAGES = {
  oneTime: [
    {
      id: 'engine_launch',
      name: 'Sales Engine — Launch',
      price: 2995,
      unit: 'one-time',
      blurb: 'A custom-coded website engineered to convert local visitors into calls, bookings and quote requests.',
      features: [
        'Custom 5–8 page conversion-focused website',
        'Mobile-first build, sub-2s load target',
        'Smart quote request form routed to your phone',
        'Google Maps, reviews & service-area pages',
        'Deployed on AWS / Cloudflare edge, SSL included',
        '30 days of post-launch support',
      ],
      featured: false,
    },
    {
      id: 'engine_scale',
      name: 'Sales Engine — Scale',
      price: 4995,
      unit: 'one-time',
      blurb: 'The full automated sales system: website, quote estimator, booking and a private owner portal.',
      features: [
        'Everything in Launch',
        'Interactive instant quote estimator',
        'Real-time calendar booking automation',
        'Instant SMS / email lead alerts',
        'Private owner portal — leads, pricing, jobs',
        '90 days of post-launch support',
      ],
      featured: true,
    },
  ],
  subscription: [
    {
      id: 'care_essentials',
      name: 'Care Plan — Essentials',
      price: 99,
      unit: '/month',
      blurb: 'We keep your engine running: hosting, security, monitoring and small updates, handled for you.',
      features: [
        'Managed edge hosting, SSL & renewals',
        'Uptime monitoring & crash-proofing',
        'Security patching & backups',
        '1 content or price update per month',
        'Email support',
      ],
      featured: false,
    },
    {
      id: 'care_growth',
      name: 'Care Plan — Growth',
      price: 249,
      unit: '/month',
      blurb: 'An engineer on call: unlimited updates, monthly conversion tuning and priority support.',
      features: [
        'Everything in Essentials',
        'Unlimited content & price updates',
        'Monthly conversion & speed optimization',
        'Monthly performance report',
        'Priority same-day support',
      ],
      featured: true,
    },
  ],
};
